import { render, staticRenderFns } from "./PwaModal.vue?vue&type=template&id=b8954c5c&scoped=true&"
import script from "./PwaModal.vue?vue&type=script&lang=js&"
export * from "./PwaModal.vue?vue&type=script&lang=js&"
import style0 from "./PwaModal.vue?vue&type=style&index=0&id=b8954c5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8954c5c",
  null
  
)

export default component.exports